
import './TabOfRoom.scss'

const TabOfRoom = ({ title, content, isActive }) => {
    return (
      <div style={{  display: isActive ? "block" : "none" }}>
        <span className='Title-room'>{title}</span>
        {content}
      </div>
    );
  };

  export default TabOfRoom

 